import { FormEvents } from 'src/framework/public/events';
import Vue from 'vue';

export default Vue.extend({
	name: 'CTrackingPixel',
	props: {
		name: { type: String, default: '' },
		url: { type: String, default: '' },
		formEvents: { type: Object, required: true }
	},
	mounted() {
		this.formEvents.on(FormEvents.AfterSubmit, this.recordSubmission);
	},
	methods: {
		generateId(maxNum) {
			return Math.floor(Math.random() * Math.floor(maxNum));
		},
		recordSubmission() {
			// Record when the form is submitted
			const noScript = document.createElement('noscript');
			const image = document.createElement('img');
			// Generate a random ID to use to detect the image element
			const id = this.generateId(16);
			image.src = this.url;
			image.id = id;
			image.setAttribute('height', '1');
			image.setAttribute('width', '1');
			noScript.appendChild(image);
			// Inject the image into the DOM
			document.getElementsByTagName('head')[0].appendChild(noScript);
		}
	},
	render() {
		return null;
	}
});